import React, { Component } from "react";
import NavBar from "../../shared/NavBar";

export class Covid19Vaccination extends Component {
  render() {
    return (
      <div>
        <NavBar />
      </div>
    );
  }
}

export default Covid19Vaccination;
